import { BreakpointObserver } from '@angular/cdk/layout';
import { Component, inject, Input, OnInit } from '@angular/core';
import { AuthenticationUser } from '../../models/authentication/authentication-user';
import { RoleService } from '../../services/role.service';

@Component({
  selector: 'app-sidenav',
  templateUrl: './sidenav.component.html',
  styleUrl: './sidenav.component.css'
})
export class SidenavComponent implements OnInit {
  @Input() currentUser: AuthenticationUser;
  collapseSidenav = true;
  collapseConfig = false;
  collapseUserMenu = true;
  showSidenavButton = false;

  private breakpointObserver = inject(BreakpointObserver);
  roleService = inject(RoleService);


  ngOnInit() {
    this.breakpointObserver.observe(['(max-width: 768px)'])
    .subscribe(result => {
      this.showSidenavButton = false;
      this.collapseSidenav = false;

      if (result.matches) {
        this.showSidenavButton = true;
        this.collapseSidenav = true;
      }
    });
  }
}
